import React from 'react';
import Timeline from '../../../Elements/Timeline';

const events = [
  { title: '1st of the month', text: 'The first ready job of the new month makes its draft.' },
  { title: 'Every morning', text: 'The new ready jobs go on their month’s draft.' },
  { title: 'You check', text: 'The draft is checked and finalized, as today.' },
  {
    title: 'A job comes late',
    text: 'A job of a month that is already finalized goes on the next open draft.',
    isHighlighted: true,
  },
];

function TimelineDemoComponent() {
  return <Timeline events={events} />;
}

export const timelineDemo = {
  id: 'timeline',
  title: 'Timeline',
  category: 'Basics',
  importPath: 'Elements/Timeline',
  notes: [
    'What happens over time, left to right: a dot for each moment on a line, its title in bold and a short text under it.',
    'events are { title, text, isHighlighted }; the moment that matters most is highlighted with a red dot.',
    'The moments share the width; on a phone they stack. In a SettingRows card it goes in the foot.',
  ],
  snippet:
    '<Timeline\n  events={[{ title: "Every morning", text: "New jobs go on." }, { title: "A job comes late", text: "…", isHighlighted: true }]}\n/>',
  render: TimelineDemoComponent,
};
